/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    d="M12 0a.9231.9231 0 1 1 0 1.8461C6.3922 1.8461 1.8461 6.3921 1.8461 12c0 5.6078 4.546 10.1538 10.1539 10.1538 5.6078 0 10.1538-4.546 10.1538-10.1538A.9231.9231 0 0 1 24 12c0 6.6274-5.3726 12-12 12S0 18.6274 0 12 5.3726 0 12 0Zm0 4.923a.923.923 0 1 1 0 1.8462c-2.8889 0-5.2308 2.342-5.2308 5.2308 0 2.8889 2.342 5.2308 5.2308 5.2308 2.8889 0 5.2308-2.3419 5.2308-5.2308a.923.923 0 1 1 1.8461 0c0 3.9085-3.1684 7.0769-7.0769 7.0769S4.923 15.9085 4.923 12 8.0916 4.923 12 4.923ZM19.2615.1746c.5778 0 1.0462.4684 1.0462 1.0461l-.0012 2.4717h2.4737c.2309 0 .454.0764.6354.215l.1036.0907c.409.4081.4096 1.0705.0015 1.4795L19.7675 9.238l-3.7008-.0008-3.414 3.4154a.923.923 0 0 1-1.3054 0c-.3277-.3277-.3575-.8405-.0894-1.2019l.0894-.1035 3.4207-3.422.0012-3.6844L18.5211.4816a1.046 1.046 0 0 1 .7404-.3071Zm-.8012 2.98-1.8461 1.8498v2.3865h2.3876l1.8487-1.8523h-2.389l-.0012-2.384Z"
  />,
  'MenuInsight'
);
